import styled from 'styled-components';
import {SignOut} from '../../assets/icons/icons';
import {fadeIn} from '../../utils/styles/animation';

export const SelectorContainer = styled.div`
  position: relative;
  margin-left: 6px;
  padding-left: 10px;
  border-left: var(--LightGray) solid 1px;
`;

export const SelectorImage = styled.img`
  cursor: pointer;
  width: 40px;
  height: 40px;
  border-radius: 50%;
`;

export const DropdownContainer = styled.div`
  top: 70%;
  right: 0%;
  z-index: 1;
  display: none;
  margin-top: 10px;
  position: absolute;
  border-radius: 8px;
  flex-direction: column;
  background-color: var(--BackgroundColor);
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.19);
  ${fadeIn({time: '250ms', type: 'ease'})}

  ${SelectorContainer}:hover &, &:hover {
    display: flex;
  }
`;

export const DropdownItem = styled.span`
  cursor: pointer;
  width: max-content;
  padding: 15px 20px;
  align-items: center;
  display: inline-flex;
  transition: 0.3s ease;
  color: var(--DarkGray);

  &:hover {
    background-color: var(--BackgroundGray);
  }

  &:last-of-type {
    width: auto;
    justify-content: space-between;
    border-top: var(--LightGray) 1px solid;
    color: var(--PrimaryRed);
  }
`;

export const DropdownIcon = styled(SignOut)``;
